// Copyright ©️ 2026 eVolve MEP, LLC

import { bendInputKeys } from '@evolvemep/api-ts';

import { WrappedSelect } from 'components/Mantine/TypeSafeSelect/WrappedSelect';
import { isNil } from 'helpers/isNotNil';
import { withoutYbcRowErrors } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/helpers';
import {
  seedYbcRows,
  useBendCreatorFormContext,
} from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorFormContext';
import { useBendCreatorValidationContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorValidationContext';
import { useBendTypes } from 'modules/Shop/EvolveFabrication/BendCreator/useBendTypes';

export const BendTypeSelect = () => {
  const { bendTypes, loading } = useBendTypes();
  const { resetLastValidation } = useBendCreatorValidationContext();
  const form = useBendCreatorFormContext();
  return (
    <WrappedSelect
      label="Bend Type"
      // Custom is added here because the bend types endpoint is the list of every shape a machine type setting can
      // cover, and no machine type setting can target Custom.
      data={isNil(bendTypes) ? [] : [...bendTypes.map(({ name }) => name), 'Custom']}
      loading={loading}
      required
      placeholder="Select a bend type"
      {...form.getInputProps('bendType')}
      onChange={(bendType) => {
        if (form.values.bendType === bendType) return;
        // On changes to the bend type, reset the dimension inputs and preview
        // and clear any errors since they could have been related to a previous selection
        form.setFieldValue('bendType', bendType);
        form.clearFieldError('bendType');
        bendInputKeys.forEach((key) => {
          form.setFieldValue(key, null);
          form.clearFieldError(key);
        });
        /* YBC rows and their errors belong to the previous selection, and Custom starts from two blank rows.
         * Custom has no leg to maximize and hides that switch, so it is turned off rather than carried over. */
        form.setFieldValue('ybcRows', bendType === 'Custom' ? seedYbcRows() : []);
        form.setErrors(withoutYbcRowErrors);
        if (bendType === 'Custom') form.setFieldValue('maximizeLegLength', false);
        resetLastValidation();
      }}
    />
  );
};
